module.exports = __webpack_public_path__ + "img/checked@3x.e77f4328.png";